import React from 'react'

import './index.scss'

interface ProgressBarProps {
  seconds: number,
  inProgress: boolean,
}

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  return (
    <>
      <div className="ProgressBar">
        <div
          className="ProgressBar__Progress"
          style={{
            transition: `ease-in-out ${props.seconds}s width`,
            width: props.inProgress ? '75%' :  `${props.seconds}`,
          }}
        />
      </div>
    </>
  )
}

export default ProgressBar
